export function migrateDisregardRegulationElection(data) {
  if (data?.hasOwnProperty("disregard_regulations_to_derivative_contracts")) {
    // --- Migrate prop (Azure Requirement 8916) --
    const { disregard_regulations_to_derivative_contracts, ...rest } = data;
    data = {
      ...rest,
      disregard_regulations_election:
        disregard_regulations_to_derivative_contracts,
    };
  }
  return data;
}

export function migrateUlt_parent_incorporation_jurisdiction(data) {
  if (data?.hasOwnProperty("ult_parent_incorporation_juristriction")) {
    // -- Migrate prop (Azure Requirement 7711) --
    const { ult_parent_incorporation_juristriction, ...rest } = data;
    data = {
      ...rest,
      ult_parent_incorporation_jurisdiction:
        ult_parent_incorporation_juristriction,
    };
  }
  return data;
}
